import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import Loading from '../../components/Loading/Loading';
import FichaTransportadorDisponivel from './FichaTransportadorDisponivel';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Api
import transportador_api from '../../api/transportador_api';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';


export default function TransportadoresDisponiveis() {
    //Estado de controle dos loading na tela
    const [loading, setLoading] = useState(false);

    //Headers da tabela de listagem de transportadores
    const headers = [
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Telefone", objectValue: "fone", align: "right" },
        { value: "Celular", objectValue: "celular", align: "right" },
        { value: "Responsável", objectValue: "responsavel", align: "left" },
        { value: "Modalidades", objectValue: "modalidades", align: "left" },
    ]

    //Variavel que guarda a lista de transportadores disponiveis
    const [transportadores, setTransportadores] = useState([]);

    //Estado de controle de exibição da ficha
    const [ficha, setFicha] = useState(null);

    //Ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    //Carrega os dados da lista da tabela
    useEffect(() => {
        setLoading(true);
        transportador_api.GetListDisponiveis().then(response => {
            response.data = response.data.map(value => {
                value.celular = !!value.celular ? mascaras.celularMask(value.celular?.replace(/\D+/g, '')) : "";
                value.fone = !!value.fone ? mascaras.celularMask(value.fone?.replace(/\D+/g, '')) : ""
                return value;
            });

            setTransportadores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null), null)
            .finally(f => setLoading(false));
    }, []);

    //Controle de exibição da ficha
    if (ficha) {
        return <FichaTransportadorDisponivel id={ficha} btnVoltar={() => setFicha(null)} />
    }
    return (
        <MainCard noCard>
            {loading && <Loading />}
            <TabelaListagem
                actions={actions}
                headers={headers}
                items={transportadores}
                title={`Lista de transportadores disponiveis`}
                options={{
                    print: false,
                    search: true,
                    pagination: true
                }}
            />
        </MainCard>
    )
}